const path = require("path");

const configment = require("@ten-x/configment");

/**
 *
 * TODO test
 * converts a string to a hashed version of that string
 *
 * e.g.
 *   http://10.1.14.187:4202
 * becomes
 *     h2d695
 *
 *
 * @param {string} str
 * @return {string}
 */
function hash(str) {
  var hash = 0;
  if (str.length === 0) return hash;
  for (var i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash = hash & hash;
  }
  return hash.toString(36);
}

/**
 * TODO test
 *
 * @return {string}
 */
function getGatewayUrlPrefix() {
  // We are defaulting to empty string only to satisfy britle unit tests.
  // In production, URL_BASE_PREFIX is always defined.
  const basePrefix = configment.get("URL_BASE_PREFIX", "");

  // TODO make this a constant, maybe even configurable?
  // Convert everything to forward slash since all API Gateways
  // don't use path.join hence forcing forward slash on the match
  // TODO maybe we should use path.join ¯\_(ツ)_/¯
  return path.join(basePrefix, "/cu/api").split(path.sep).join("/");
}

/**
 * TODO test
 *
 * @param {URL} url
 * @return {string}
 */
function calcGatewayPathname(url) {
  const maskedHost = url.host.replace(
    /(\d{1,3}\.\d{1,3}\.\d{1,3}\.)\d{1,3}(:\d{2,4})/,
    "$1XXX$2"
  );

  const prefix = getGatewayUrlPrefix();

  // Convert everything to forward slash since all API Gateways
  // don't use path.join hence forcing forward slash on the match
  // TODO maybe we should use path.join ¯\_(ツ)_/¯
  return path
    .join(prefix, hash(maskedHost), url.pathname)
    .split(path.sep)
    .join("/");
}

module.exports = { calcGatewayPathname, getGatewayUrlPrefix, hash };
